<template>
    <fieldset class="flex flex-col gap-1">
        <label v-if="!hideLabel" :for="inputId" class="font-bold">
            {{ label }}
            <span v-if="required" class="text-danger">*</span>
        </label>
        <slot :input-id :touch />
        <div v-if="description" class="text-sm text-muted" v-html="description"></div>
        <div v-if="issues[key]" class="text-sm text-danger">{{ issues[key] }}</div>
    </fieldset>
</template>
<script setup lang="ts">
import type { FormFieldProps } from "~/utils/types/FormFieldProps";
import { FormInjectKey } from "../form/Form.vue";
const {
    label,
    field: key,
    required = false,
    description = "",
    hideLabel = false,
} = defineProps<FormFieldProps & { hideLabel?: boolean }>();

const { issues, touched } = inject(FormInjectKey, {
    issues: computed<Record<string, string>>(() => ({})),
    touched: ref<Record<string, boolean>>({}),
});

const inputId = "form-field-" + key.toLowerCase();

function touch() {
    touched.value[key] = true;
}
</script>
